// import React, { useState } from 'react';
// import {
//   Box,
//   Container,
//   TextField,
//   Button,
//   Typography,
//   Paper,
//   Alert,
//   CircularProgress,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';

// function AdminLogin() {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//   });
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//     setError('');
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     // Determine API URL based on environment
//     const API_BASE_URL = 
//       process.env.REACT_APP_ENV === 'production' 
//         ? process.env.REACT_APP_API_URL 
//         : process.env.REACT_APP_DEV_API_URL || 'http://localhost:5000/api';

//     try {
//       console.log('Attempting to login...', `${API_BASE_URL}/auth/login`);
      
//       const response = await fetch(`${API_BASE_URL}/auth/login`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify(formData),
//         credentials: 'include',
//         mode: 'cors'
//       });

//       console.log('Response status:', response.status);

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error('Server error response:', errorText);
//         throw new Error(errorText || 'Login failed');
//       }

//       const data = await response.json();
//       console.log('Login response data:', data);

//       if (data.user.role !== 'admin') {
//         throw new Error('Unauthorized access. Admin privileges required.');
//       }

//       // Store token and user data
//       localStorage.setItem('token', data.token);
//       localStorage.setItem('user', JSON.stringify(data.user));

//       // Redirect to admin dashboard
//       navigate('/admin-dashboard');
//     } catch (error) {
//       console.error('Detailed login error:', {
//         message: error.message,
//         name: error.name,
//         stack: error.stack
//       });
      
//       // More comprehensive error handling
//       if (error.message.includes('Failed to fetch')) {
//         setError('Network error. Unable to connect to the server. Check your connection and server status.');
//       } else if (error.message.includes('CORS')) {
//         setError('Cross-Origin Resource Sharing (CORS) error. Please contact system administrator.');
//       } else {
//         setError(error.message || 'An unexpected error occurred. Please try again.');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Container component="main" maxWidth="xs">
//       <Box
//         sx={{
//           marginTop: 8,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//         }}
//       >
//         <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
//           <Typography component="h1" variant="h5" align="center" gutterBottom>
//             Admin Login
//           </Typography>
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {error}
//             </Alert>
//           )}
//           <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
//             <TextField
//               margin="normal"
//               required
//               fullWidth
//               id="email"
//               label="Email Address"
//               name="email"
//               autoComplete="email"
//               autoFocus
//               value={formData.email}
//               onChange={handleChange}
//               disabled={loading}
//             />
//             <TextField
//               margin="normal"
//               required
//               fullWidth
//               name="password"
//               label="Password"
//               type="password"
//               id="password"
//               autoComplete="current-password"
//               value={formData.password}
//               onChange={handleChange}
//               disabled={loading}
//             />
//             <Button
//               type="submit"
//               fullWidth
//               variant="contained"
//               sx={{ mt: 3, mb: 2 }}
//               disabled={loading}
//             >
//               {loading ? (
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <CircularProgress size={24} sx={{ mr: 1 }} />
//                   Signing in...
//                 </Box>
//               ) : (
//                 'Sign In'
//               )}
//             </Button>
//             <Typography variant="body2" color="text.secondary" align="center">
//               Use admin@gmail.com / admin123
//             </Typography>
//           </Box>
//         </Paper>
//       </Box>
//     </Container>
//   );
// }

// export default AdminLogin;
import React, { useState } from 'react';
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

function AdminLogin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError(''); // Clear error when typing
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // For testing purposes, let's assume admin credentials are:
    const adminEmail = 'admin@gmail.com';
    const adminPassword = 'admin123';

    try {
      // Check if the email and password match the hardcoded credentials
      if (formData.email === adminEmail && formData.password === adminPassword) {
        // Directly simulate a successful login without calling the backend
        // Store dummy token and user data (for testing)
        const user = { email: adminEmail, role: 'admin' };
        const token = 'dummy-token'; // In a real app, you'd get this from the backend

        // Store the token and user data in localStorage (for demonstration purposes)
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));

        // Redirect to admin dashboard
        navigate('/admin-dashboard');
      } else {
        throw new Error('Invalid email or password.');
      }
    } catch (error) {
      console.error('Login error:', error.message);
      setError(error.message || 'An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%' }}>
          <Typography component="h1" variant="h5" align="center" gutterBottom>
            Admin Login
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              value={formData.email}
              onChange={handleChange}
              disabled={loading}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={loading}
            >
              {loading ? (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Signing in...
                </Box>
              ) : (
                'Sign In'
              )}
            </Button>
            <Typography variant="body2" color="text.secondary" align="center">
              Use admin@gmail.com / admin123 for testing
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default AdminLogin;
